<div class='SelectManagerDialog'>
  <div class='SelectManagerDialog__header'>
    <div *ngIf="currentUser.user_type === 'master' && user.account_role === 'user'" class='alert alert-danger'>
      <p>You are about to change the management of the user.</p>
      <p>If user was previously assigned under another manager, the old manager's user will be decreased. The new
        manager will absorb the monthly cost of the new user</p>
    </div>
  </div>
  <div [formGroup]='inputForm' class='SelectManagerDialog__body'>
    <div class='SelectManagerDialog__body__selection'>
      <app-select
        *ngIf="currentUser.user_type === 'master' && user.account_role === 'user'"
        [defaultValue]='0'
        [items]='getManagers()'
        [label]="'Select manager'"
        formControlName='manager_id'></app-select>
      <mat-icon (click)='resetManager()' *ngIf='user.manager_id'>close</mat-icon>
    </div>
    <ng-container *ngIf="user.account_role !== 'manager' && false; else managedUsers">
      <div *ngIf='manager_id !== user.manager_id && manager_id !== ""' class='SelectManagerDialog__body__controls'>
        <p>Subscription paid by</p>
        <mat-radio-group
          aria-label='Select an user type' formControlName='paid_by'>
          <mat-radio-button class='me-2' value='manager'>New Manager</mat-radio-button>
          <mat-radio-button class='ms-2' value='user'>User {{ user.account_id }}, {{ user.email }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </ng-container>
    <ng-template #managedUsers>
      <app-table
        *ngIf='tableReady'
        [columns]='tableColumns'
        [dataSourceParams]='dataSourceParams'
        [dataSource]='dataSource'
        [emptyDataText]="emptyDataText"
        [selectable]='false'></app-table>
    </ng-template>
  </div>
</div>
